import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setTotalGpSummaryAction } from "@oldDashboard/legacyActions/dashboardClient";

interface UseTotalGpSummaryProps { launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, searching: boolean }
const UseTotalGpSummary = (props: UseTotalGpSummaryProps) => {
    const { launchSelected, startDate, endDate, searching } = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchTotalGpSummary();
    }, [searching,launchSelected]);


    const fetchTotalGpSummary = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getTotalGpSummary(launchSelected, startDate, endDate);
            if(response.success) {
                const { total_activated, total_awaiting } = response.chart_data.data;
                setTotalGpSummaryAction({totalActivated: total_activated,totalAwaiting:total_awaiting});
            }

        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
     
    }
    return { isLoading, fetchTotalGpSummary}
}

export default UseTotalGpSummary;